import { graphql } from 'react-relay';

// language=GraphQL
const autoProcessBrokerActivityPerformance = graphql`
  mutation AutoProcessBrokerActivityPerformanceMutation (
    $performanceType: PerformanceType!
    $brokerActivityGroupId: ID!
  ) {
    autoProcessBrokerActivityPerformance(
      performanceType: $performanceType,
      brokerActivityGroupId: $brokerActivityGroupId
    ) {
      brokerActivities {
        brokeractivitytransactionSet {
          edges {
            node {
              brokeractivitytransactionperformanceSet {
                edges {
                  node {
                    ...Performance_batPerformance @relay(mask: false)
                  }
                }
              }
            }
          }
        } 
      }
    }
  }
`;

export default autoProcessBrokerActivityPerformance;
